import { axiosClient, type IResponse  } from '~/common/js/axios';
 import type { AxiosRequestConfig } from 'axios';
export interface create_POST_res_type {
  /** 委托单ID */ 
  adId: string 
}
/**
* 发布委托单
*/
export function create_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<create_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/create',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 更新委托单详情
*/
export function updateDetail_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/ad/updateDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 删除委托单
*/
export function delete_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/ad/delete',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 委托单上下线
*/
export function offOrOnLine_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/ad/offOrOnLine',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

/**
* 委托单关联信息
*/
export function getAdRelationInfo_get(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/ad/getAdRelationInfo',
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    params: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getTradeAdInfo_POST_res_type {
  /** 委托单id */ 
  adId: number 
  /** 商家cid */ 
  cid: number 
  /** 商家昵称 */ 
  nickName: string 
  /** 买卖类型筛选,buy,sell */ 
  side: string 
  /** 法币 */ 
  currency: string 
  /** 法币精度 */ 
  currencyScale: number 
  /** 虚拟币 */ 
  crypto: string 
  /** 虚拟币精度 */ 
  cryptoScale: number 
  /** 币种ID */ 
  coinId: number 
  /** 虚拟币图标 */ 
  cryptoUrl: string 
  /** 价格类型，fixed */ 
  priceType: string 
  /** 价格 */ 
  price: string 
  /** 总金额 */ 
  amount: string 
  /** 总数量 */ 
  size: string 
  /** 可用数量 */ 
  availableSize: string 
  /** 交易限制：最小交易数量，法币 */ 
  minAmount: string 
  /** 交易限制：最大交易数量，法币 */ 
  maxAmount: string 
  /** 委托单描述 */ 
  information: string 
  /** 支付倒计时:  单位分钟: 15, 30, 60 */ 
  payTimeLimitType: number 
  /** UserMerchantRelation */ 
  merchantRelation: object 
  /** 当前用户支持的委托单设置的支付方式 ,AdPayTypeVO */ 
  supportPayTypeList: Array<any> 
}
/**
* 获取下单交易的委托单信息
*/
export function getTradeAdInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getTradeAdInfo_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/getTradeAdInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getAdDetail_POST_res_type {
  /** 委托单ID */ 
  adId: number 
  /** 买卖类型  buy,  sell */ 
  side: string 
  /** 法币币种名称 */ 
  currency: string 
  /** 法币精度 */ 
  currencyScale: string 
  /** 虚拟币币种名称 */ 
  crypto: string 
  /** 虚拟币精度 */ 
  cryptoScale: string 
  /** 币种ID */ 
  coinId: string 
  /** 虚拟币icon */ 
  cryptoUrl: string 
  /** 价格类型 :  fixed 表示固定 */ 
  priceType: string 
  /** 价格 */ 
  price: string 
  /** 法币金额 */ 
  amount: string 
  /** 虚拟币数量 */ 
  size: string 
  /** 当前剩余可交易的虚拟币数量 */ 
  availableSize: string 
  /** 交易最小限额 */ 
  minAmount: string 
  /** 交易最大限额 */ 
  maxAmount: string 
  /** 支付方式集合 */ 
  payTypeList: Array<any> 
  /** 委托单kyc等级限制类型:  KYC1、 KYC2 */ 
  kycLevelLimit: string 
  /** 委托单kyc时间限制类型： 30day、90day、180day、365day */ 
  signUpLimitType: string 
  /** 委托单国家限制类型：all */ 
  countryLimitType: string 
  /** 用户限制的国家  逗号,拼接(暂时不需要) */ 
  countryLimits: string 
  /** 支付倒计时:  单位分钟: 15, 30, 60 */ 
  payTimeLimitType: number 
  /** 委托单描述 */ 
  information: string 
  /** 委托单状态： active, inActive */ 
  state: string 
  /** 更新时间 */ 
  updateTime: string 
  /** 委托单市场类型：Public */ 
  adMarketType: string 
  updateDel?: boolean
}
/**
* 查询单个委托单详情
*/
export function getAdDetail_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getAdDetail_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/getAdDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getAdList_POST_res_type {
  /** 委托单集合 */ 
  items: Array<any> 
  /** 当前用户已创建的委托单的法币集合 */ 
  currencyList: Array<any> 
  /** 商家在线状态：true 在线， false 下线 */ 
  merchantState: boolean 
}
/**
* 查询委托单列表
*/
export function getAdList_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getAdList_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/getAdList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getAdBook_POST_res_type {
  /** 盘口委托单列表 */ 
  items: Array<any> 
  /** 委托单查询过滤条件 */ 
  adFilterRules: object 
}
/**
* 查询委托单盘口(公开)
*/
export function getAdBook_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getAdBook_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/getAdBook',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getAdBookByMerchant_POST_res_type {
  /** 商家的买币委托单列表 ,对用户展示的sell */ 
  buyItems: Array<any> 
  /** 商家的卖币委托单列表 ,对用户展示的buy */ 
  sellItems: Array<any> 
}
/**
* 根据商家cid查询商家的公开的委托单列表(公开)
*/
export function getAdBookByMerchant_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getAdBookByMerchant_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/getAdBookByMerchant',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface createCheck_post_POST_res_type {
  /** 商家的买币委托单列表 ,对用户展示的sell */ 
  bizCode: number; 
  /** 商家的卖币委托单列表 ,对用户展示的buy */ 
  leftLimitHours: number 
}
export function createCheck_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<createCheck_post_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/ad/createCheck',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export const CANCEL_PIGEON_CODE = 48238;
